export { IconGenIcon } from './IconGenIcon';
export type { IconGenIconProps } from './IconGenIcon';

// Utility functions for IconGen integration
export const generateIconClassName = (iconName: string): string => {
  return `icon-${iconName.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')}`;
};

export const getIconApiUrl = (userId: string, iconName: string, baseUrl = 'https://icongen.pro'): string => {
  const cleanIconName = encodeURIComponent(iconName);
  return `${baseUrl}/api/icons/${userId}/${cleanIconName}`;
};

export const getCssLibraryUrl = (userId: string, baseUrl = 'https://icongen.pro'): string => {
  return `${baseUrl}/api/css/${userId}/icons.css`;
};
